import {
  createReportFilterPresetV1,
  deleteReportFilterPresetV1,
  retrieveReportFilterPresetsV1,
  type CreateReportFilterPresetInput,
  type DeleteReportFilterPresetInput,
  type RetrieveReportFilterPresetsInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";
import { type APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import toast from "react-hot-toast";

export const retrieveReportFilterPresetsQueryOptions = (
  filters?: RetrieveReportFilterPresetsInput,
) => ({
  queryKey: [queryKeys.reports, "report-filter-presets", filters],
  queryFn: () => retrieveReportFilterPresetsV1(filters),
});

export const useCreateReportFilterPreset = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateReportFilterPresetInput) =>
      createReportFilterPresetV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error saving report preset");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.reports, "report-filter-presets"],
      });
    },
    onSuccess: () => {
      toast.success("Report preset saved successfully");
    },
  });
};

export const useDeleteReportFilterPreset = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DeleteReportFilterPresetInput) =>
      deleteReportFilterPresetV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting report preset");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.reports, "report-filter-presets"],
      });
    },
    onSuccess: () => {
      toast.success("Report preset deleted successfully");
    },
  });
};
